import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Space, Typography, Spin } from 'antd'
import styled, { css } from 'styled-components'
import NumberFormat from 'react-number-format'
import { ArrowUpOutlined, DownOutlined, BarChartOutlined } from '@ant-design/icons'
import PriceChart from './PriceChart'
import { getWelInfo } from '@/actions/welInfo'
import { fetchWelPrice } from '@/actions/home'
import Tag from '@/v2/components/tag'
import StatisticItem from './StatisticItem'
const { Title, Text } = Typography

const Wrapper = styled.div`
  margin-bottom: 25px;
`
const Card = styled(Row)`
  background-color: ${({ theme }) => theme.colors_v2.dark_blue};
  border-radius: 16px;
  position: relative;
  min-height: 270px;
`

const StyledTitle = styled(Title)`
  margin-bottom: 0 !important;
  color: #ffffff !important;
  font-size: 20px !important;
  margin-top: 12px !important;
  line-height: 24px !important;
`

const AlignRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`
const LatestPrice = styled(Row)`
  padding: 25px 20px 16px 20px;
  position: relative;
  z-index: 1;

  &:after {
    content: '';
    position: absolute;
    width: calc(100% - 40px);
    bottom: 0px;
    margin: auto;
    height: 1px;
    background: #312d70;
  }
`
const Background = styled.div`
  background-color: #ffffff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  padding: 8px;
  display: flex;
  align-items: center;

  img {
    width: 100%;
    object-fit: contain;
    margin-top: 5px;
    margin-left: -2px;
  }
`
const StyledTag = styled(Tag)`
  margin: 0 0 5px 0;
  width: fit-content;
  margin-bottom: 8px;
  padding: 2px 8px;
`
const MarketItem = styled(Row)`
  padding: 20px 20px 0px;
  .anticon {
    width: 35px;
    height: 35px;
    border: 1px solid #d7d7d7;
    border-radius: 50%;
    padding-top: 8px;
  }
  .ant-typography {
    font-weight: normal;
    font-size: 15px;
  }
`

const FlexCenter = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  > h4 {
    margin-top: 0px !important;
    margin-bottom: 8px !important;
  }
`
const PriceLable = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 8px;
  height: 22px;
  b {
    span {
      font-size: 16px;
      line-height: 16px;
      display: block;
    }
  }
`
const PriceUnit = styled.span`
  font-size: 14px;
  line-height: 14px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors_v2.grey};

  &:before {
    content: '/';
    font-size: 10px;
    line-height: 10px;
    display: block;
    margin-top: 1px;
  }
`

const TextLable = styled.label`
  color: ${({ theme }) => theme.colors_v2.grey};
`

const StatisticRow = styled(Row)`
  width: 100%;
  position: relative;
  padding: 20px 0px;
  @media (max-width: 768px) {
    padding: 0px;
  }

  &:before {
    content: '';
    width: calc(100% - 40px);
    height: 1px;
    background: #312d70;
    margin: auto;
    position: absolute;
    top: 0px;
    left: 20px;

    @media (max-width: 768px) {
      content: unset;
    }
  }

  &:first-child {
    &:before {
      content: unset;
    }
  }
`

const CollapseWrapper = styled(Row)`
  width: 100%;

  @media (max-width: 768px) {
    display: block !important;
  }

  ${StatisticRow} {
    &:first-child {
      &:before {
        content: '';

        @media (max-width: 768px) {
          content: unset;
        }
      }
    }
  }
`

const CollapseIcon = styled.div`
  position: absolute;
  display: block;
  border: solid ${({ theme }) => theme.colors_v2.primary_yellow};
  border-width: 0px 3px 3px 0px;
  padding: 3px;
  background: transparent;
  border-radius: 2px;
  bottom: 20px;
  left: 50%;
  margin-left: -3px;
  cursor: pointer;

  &.up {
    transform: rotate(-135deg);
    -webkit-transform: rotate(-135deg);
  }
  &.down {
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
  }

  @media (max-width: 768px) {
    display: none;
  }
`
class Statistic extends Component {
  constructor() {
    super()
    this.collapseWrapper
    this.state = {
      isCollapse: true,
    }
  }
  componentDidMount() {
    this.props.getWelInfo()
    this.props.getWelPrice()
  }

  toggleCollapse = () => {
    this.setState({
      isCollapse: !this.state.isCollapse,
    })
  }

  render() {
    const { welInfo } = this.props.welInfo
    const { welPrice } = this.props
    const { isCollapse } = this.state
    const collapseDirection = isCollapse ? 'down' : 'up'

    return (
      <Wrapper>
        <Row gutter={[16, 16]}>
          <Col md={12} lg={16} span={24}>
            <Card>
              <StatisticRow>
                <StatisticItem
                  title="Total Supply"
                  value={welInfo?.total_supply}
                  changedValue={welInfo?.total_supply_change}
                  color="#F7C11A"
                  changedValuePrefix="+"
                />
                <StatisticItem
                  title="Total Circulating"
                  value={welInfo?.total_circulating}
                  changedValue={welInfo?.total_circulating_change}
                  color="#3CB09B"
                  changedValuePrefix="+"
                />
              </StatisticRow>
              <StatisticRow>
                <StatisticItem
                  title="TVL"
                  value={welInfo?.tvl * welPrice?.latest}
                  changedValue={welInfo?.tvl_change}
                  color="#D35D64"
                  prefix="$"
                  changedValuePrefix="+"
                />

                <StatisticItem
                  title="Fully Diluted MC"
                  value={welInfo?.total_supply * welPrice?.latest}
                  changedValue={
                    (welInfo?.total_supply_change /
                      (welInfo?.total_supply - welInfo?.total_supply_change)) *
                    100
                  }
                  prefix="$"
                  changedValuePrefix="+"
                  changedValueSuffix="%"
                  color="#D531C4"
                />
                <CollapseIcon
                  onClick={this.toggleCollapse}
                  className={isCollapse ? 'down' : 'up'}
                />
              </StatisticRow>
              <CollapseWrapper ref={this.collapseWrapper} hidden={isCollapse}>
                <StatisticRow>
                  <StatisticItem
                    title="Total WELUPS Staked"
                    value={welInfo?.tvl}
                    changedLable="Staking Rate"
                    changedValue={(welInfo?.tvl / welInfo?.total_supply) * 100}
                    changedValueSuffix="%"
                    changedValuePrefix={null}
                    changedValueDecimalScale={2}
                    color="#1467DA"
                  />
                </StatisticRow>
              </CollapseWrapper>
            </Card>
          </Col>
          <Col md={12} lg={8} span={24}>
            <Card>
              <Col span={24}>
                <LatestPrice align="middle" justify="space-between">
                  <Col>
                    <Space align="center">
                      <Background>
                        <img src="/images/logo_home.png" width={40} />
                      </Background>
                      <FlexCenter>
                        <StyledTitle level={4}>WELUPS</StyledTitle>
                        <TextLable>Latest Price</TextLable>
                      </FlexCenter>
                    </Space>
                  </Col>
                  <AlignRight>
                    <StyledTag color={welPrice?.change < 0 ? 'red' : 'green'}>
                      {(welPrice?.change < 0 ? `-` : `+`) + `${Math.abs(welPrice?.change)}% `}
                    </StyledTag>
                    <PriceLable>
                      {welPrice?.latest ? (
                        <b>
                          <NumberFormat
                            displayType="text"
                            thousandSeparator={true}
                            prefix="$"
                            value={welPrice.latest}
                          />
                        </b>
                      ) : (
                        <Spin size="small" />
                      )}
                      <PriceUnit>Welups</PriceUnit>
                    </PriceLable>
                  </AlignRight>
                </LatestPrice>
                <MarketItem align="middle" justify="space-between">
                  <Col>
                    <Space align="start" size="middle">
                      <div>
                        <TextLable>Market Cap</TextLable>
                        <PriceLable level={5}>
                          {welPrice?.latest ? (
                            <b>
                              <NumberFormat
                                displayType="text"
                                thousandSeparator={true}
                                decimalScale={3}
                                prefix="$"
                                value={welInfo?.total_circulating * welPrice?.latest}
                              />
                            </b>
                          ) : (
                            <Spin size="small" />
                          )}
                        </PriceLable>
                      </div>
                    </Space>
                  </Col>
                  <Col>
                    <Space>
                      <StyledTag color={welPrice?.change < 0 ? 'red' : 'green'}>
                        {(welPrice?.change < 0 ? `-` : `+`) + `${Math.abs(welPrice?.change)}% `}
                      </StyledTag>
                    </Space>
                  </Col>
                </MarketItem>
                <PriceChart />
              </Col>
            </Card>
          </Col>
        </Row>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    welInfo: state.welInfo,
    welPrice: state.welPrice || {},
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getWelInfo: () => {
      dispatch(getWelInfo())
    },
    getWelPrice: () => {
      dispatch(fetchWelPrice())
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(Statistic)
